import { createContext } from 'react';

// Create a new context
const ChampionDataContext = createContext({version: "13.11.1"});

export default ChampionDataContext;